import { render, staticRenderFns } from "./AgentCommissionRounds.vue?vue&type=template&id=47724321&"
import script from "./AgentCommissionRounds.vue?vue&type=script&lang=js&"
export * from "./AgentCommissionRounds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports